import { useContext, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Modal from 'components/modal/Modal';
import messages from 'messages';
import {
  CardHeader,
  CardHeaderTitle,
  CardHeaderSubtitle
} from 'components/card/card-header';
import { ButtonsGroup, Button } from 'components/button';
import { CardBody, CardFooter } from 'components/card';
import ReportOptions from 'containers/partials/forms/ReportOptions';
import { MODAL_TYPES } from 'models/ModalData';
import {
  downloadAllSessionReports,
  downloadSkReports,
  downloadSkReportSession
} from 'services/aws/session-query';
import { StoreContext } from 'index';
import { pollIsValidUrl } from 'utils/url';
import { openWindowWithLoader } from 'utils/browser';
import { useSessionContext } from 'contexts/SessionContext';
import Loader from 'components/loader/Loader';
import { uid } from 'react-uid';
import { QRCodeSVG } from 'qrcode.react';
import { sortSportersOnFinishedAndDate } from 'utils/sort';

const GenerateQRCodeModal = ({ entityId, onClose }) => {
  const intl = useIntl();
  const { uiState } = useContext(StoreContext);
  const { session, options } = useSessionContext();
  const [isLoading, setIsLoading] = useState(false);

  const onCloseHandler = () => {
    if (onClose) onClose();
  };

  const getQRObject = sporter => {
    return JSON.stringify({
      e: entityId,
      p: sporter.id,
      s: session.id
    });
  };

  return (
    <Modal card largeBody isOpen={true} onClose={onCloseHandler}>
      <CardHeader modal>
        <CardHeaderTitle>Print session QR codes</CardHeaderTitle>
      </CardHeader>

      <CardBody modal>
        <div className="o-layout o-layout--tiny">
          {sortSportersOnFinishedAndDate(session.sporters).map(sporter => {
            return (
              <div
                className="o-layout__item u-1-of-3-at-small "
                key={sporter.id}
                style={{ marginBottom: '80px' }}
              >
                <div>
                  <h3>
                    {sporter.firstname} {sporter.lastname}
                  </h3>
                  <QRCodeSVG value={getQRObject(sporter)} size={128} />
                </div>
              </div>
            );
          })}
        </div>
      </CardBody>
    </Modal>
  );
};

export default GenerateQRCodeModal;
